/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { CircularProgress, Grid } from '@mui/material';

export const LoadingForSuspense = () => {
    return (
        <Grid
            container
            alignItems="center"
            style={{
                width: '100%',
                height: '100vh',
                justifyContent: 'center',
            }}
        >
            <CircularProgress />
        </Grid>
    );
};
